var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup1000008552(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 26.0757L24.3892 23C26.9331 25.3306 29.7029 27.7896 32.3617 30.3482C33.2683 31.2203 33.1881 32.3734 32.2549 33.2573C31.2581 34.2013 30.0148 34.2577 28.991 33.3561C26.2555 30.9473 23.6021 28.4568 21 26.0757Z",
    fill: "#F7B53C",
    stroke: "black",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 26C20.4036 26 26 20.4036 26 13.5C26 6.59644 20.4036 1 13.5 1C6.59644 1 1 6.59644 1 13.5C1 20.4036 6.59644 26 13.5 26Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 16.7389C11.4151 17.2451 11.9843 17.609 12.625 17.7778C14 18.1444 15.4375 17.4722 15.75 16.3722C16 15.15 14.9375 13.9278 13.5 13.6222C12.0625 13.2556 11 11.9722 11.3125 10.8722C11.625 9.71111 13 9.03889 14.4375 9.46667C15.0625 9.58889 15.5625 9.95556 16 10.4444M13.5625 17.7778V19M13.5625 8V9.34444",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 7L7 20",
    stroke: "black",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1000008552);
export default __webpack_public_path__ + "static/media/Group 1000008552.d683f3673cd05aba821817bf1bb51f17.svg";
export { ForwardRef as ReactComponent };